import React from 'react';

const NewsTitle = () => {
    return (
        <div className="title">
            <h2>Assessing the Maturity of Your Data Management in Industry</h2>
        </div>
    );
};

export default NewsTitle;
